import apiActionsTypes from '../actions/api-action-types';

const initialState = {
  copiesList: [],
  isLoading: false,
  error: null,
};

const copiesListReducer = (state = initialState, action) => {
  switch (action.type) {
    case apiActionsTypes.GET_COPIES_LIST_DATA_START: {
      return { ...state, isLoading: true };
    }
    case apiActionsTypes.GET_COPIES_LIST_DATA_SUCCESS: {
      const copies = action.data?.data.reduce(
        (acc, copy) => ({
          ...acc,
          [copy.key]: copy.url,
        }),
        {}
      );
      return {
        ...state,
        copiesList: copies,
        isLoading: false,
      };
    }
    case apiActionsTypes.GET_COPIES_LIST_DATA_FAIL: {
      const error = action.data;
      return { ...state, isLoading: false, error };
    }

    default:
      return state;
  }
};

export default copiesListReducer;
